import styled, { css } from 'styled-components';
import { Typography } from '../../index';

export const Label = styled.label<{ disabled?: boolean }>`
    position: relative;
    display: flex;
    cursor: pointer;

    ${props =>
        props.disabled &&
        css`
            color: ${props => props.theme.root.colors.basicColors['40%']};
        `}

    &:before {
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 2px solid ${props => props.theme.root.colors.basicColors['40%']};
        transition: border 0.5s;
        margin: 3px 16px 3px 3px;
    }
`;

export const Input = styled.input<{
    checked?: boolean;
    isDangerSelection?: boolean;
}>`
    position: absolute;
    visibility: hidden;

    &:disabled + ${Label} {
        cursor: default;
        &:before {
            border-color: ${props => {
                if (!props.checked) return props.theme.root.colors.basicColors['80%'];
                if (props.checked && props.isDangerSelection) {
                    return props.theme.root.colors.system['danger40%'];
                }

                return props.theme.root.colors.primary['40%'];
            }};
        }
    }

    &:checked + ${Label} {
        &:before {
            border-color: ${props => {
                if (props.isDangerSelection) {
                    return props.theme.root.colors.system.dangerDefault;
                }

                return props.theme.root.colors.primary.default;
            }};
            box-shadow: inset 0 0 0 3px ${props => props.theme.root.colors.background['01Base']};
            background-color: ${props =>
                props.isDangerSelection
                    ? props.theme.root.colors.system.dangerDefault
                    : props.theme.root.colors.primary.default};
        }
    }
`;

export const LabelContents = styled.span<{ oneRow?: boolean }>`
    display: ${props => (props.oneRow ? 'contents' : 'flex')};
    flex: 1 1;
    flex-direction: column;
`;

export const LabelText = styled(Typography)`
    margin-right: 4px;
    margin-top: 2px;

    font-weight: 500;
    display: flex;
`;

export const Description = styled(Typography)`
    margin-top: 4px;
`;

export const InputWrapper = styled.span`
    display: flex;
    align-items: center;

    & + & {
        margin-top: 16px;
    }
`;
